const JWT_SECRET = process.env.REACT_APP_JWT_SECRET || 'your-secret-key-change-in-production';

const decodeJWT = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const decoded = JSON.parse(atob(parts[1]));
    const now = Math.floor(Date.now() / 1000);
    
    if (decoded.exp && decoded.exp < now) {
      return null;
    }
    
    return decoded;
  } catch (error) {
    return null;
  }
};

export const createJWT = (payload) => {
  const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
  const exp = Math.floor(Date.now() / 1000) + (7 * 24 * 60 * 60);
  const body = btoa(JSON.stringify({ ...payload, exp, iat: Math.floor(Date.now() / 1000) }));
  const signature = btoa(JWT_SECRET + '.' + body);
  return `${header}.${body}.${signature}`;
};

export const verifyJWT = (token) => {
  return decodeJWT(token);
};

export const getStoredToken = () => {
  return localStorage.getItem('adminToken');
};

export const setStoredToken = (token) => {
  localStorage.setItem('adminToken', token);
};

export const clearStoredToken = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

export const getStoredUser = () => {
  const user = localStorage.getItem('adminUser');
  return user ? JSON.parse(user) : null;
};

export const setStoredUser = (user) => {
  localStorage.setItem('adminUser', JSON.stringify(user));
};

export const hasPermission = (userPermissions, requiredPermission) => {
  if (!Array.isArray(userPermissions)) return false;
  return userPermissions.some(p => p.name === requiredPermission || p === requiredPermission);
};

export const hasAnyPermission = (userPermissions, requiredPermissions) => {
  if (!Array.isArray(userPermissions) || !Array.isArray(requiredPermissions)) return false;
  return requiredPermissions.some(req => 
    userPermissions.some(p => p.name === req || p === req)
  );
};

export const hasAllPermissions = (userPermissions, requiredPermissions) => {
  if (!Array.isArray(userPermissions) || !Array.isArray(requiredPermissions)) return false;
  return requiredPermissions.every(req =>
    userPermissions.some(p => p.name === req || p === req)
  );
};

export const isAuthenticated = () => {
  const token = getStoredToken();
  if (!token) return false;
  const decoded = verifyJWT(token);
  return decoded !== null;
};
